import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import servicesData from "../../../assets/data/servicesData.json"; // Adjust the import path as necessary
import HeaderOne from "../../Layouts/Headers/HeaderOne";
import InnerPageTitle from "../../Helpers/InnerPageTitle";
import FooterOne from "../../Layouts/Footers/FooterOne";
import MainWid from "./MainWid"; // Make sure MainWid is adjusted to accept and use the serviceDetails prop
import BrandAreaWid from "../../Common/BrandAreaWid";

function ServiceDetails() {
  const { serviceLink } = useParams(); // Extract the "serviceLink" from the URL
  const [serviceDetails, setServiceDetails] = useState(null);

  useEffect(() => {
    console.log("Current serviceLink: ", serviceLink);
    const service = servicesData.find((s) => s.links === serviceLink);
    setServiceDetails(service);
  }, [serviceLink]);
  if (!serviceDetails) {
    return <div>Loading service details...</div>; // or any other loading indicator
  }

  return (
    <>
      <HeaderOne />
      <main>
        <InnerPageTitle
          title={serviceDetails.title}
          paths={[
            { name: "Domů", path: "/" },
            { name: "Služby", path: "/services" },
            { name: serviceDetails.title, path: `/services/${serviceLink}` },
          ]}
        />
        <MainWid key={serviceLink} serviceLink={serviceLink} />
        <BrandAreaWid className="pt-0" />
      </main>
      <FooterOne />
    </>
  );
}

export default ServiceDetails;
